import { dropdownEllipsisWidth } from "ds/components/DropdownMenu/constants";
import { TableColumnMeta } from "ds/components/Table/types";
import { AnalyticsPageContext } from "hooks/useAnalytics/pages/context";
import { Spacing } from "types/Spacing";
import { SearchQueryOrderDirection } from "types/generated";

export const COLUMN_ORDER = `minmax(4rem, 6fr) minmax(10rem, 1fr) minmax(20rem, 1fr) ${dropdownEllipsisWidth}`;

export const COLUMN_GAP: Spacing = "large";

export enum FilterItemKeys {
  Name = "name",
  Space = "space",
  CreatedAt = "createdAt",
}

export const FILTER_ITEMS_DICTIONARY: Partial<Record<FilterItemKeys, string>> = {
  [FilterItemKeys.Name]: "Name",
  [FilterItemKeys.Space]: "Space",
  [FilterItemKeys.CreatedAt]: "Created at",
};

export const INITIAL_SORT_OPTION = FilterItemKeys.CreatedAt;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
export const FILTERS_ORDER_SETTINGS_KEY = "contextsFiltersOrder";

export const CONTEXTS_PER_PAGE = 50;

export const CONTEXTS_LIST_ITEM_TEST_ID = "contexts-list-item";

export const CONTEXT_ANALYTICS_VERSION = "Context v1";

export enum CONTEXTS_COLUMN_ID {
  NAME = "NAME",
  LABELS = "LABELS",
  SPACE = "SPACE",
  CREATED_AT = "CREATED_AT",
  DESCRIPTION = "DESCRIPTION",
  DROPDOWN = "DROPDOWN",
}

export const SORT_CONFIG: Record<string, string> = {
  [CONTEXTS_COLUMN_ID.NAME]: "name",
  [CONTEXTS_COLUMN_ID.CREATED_AT]: "createdAt",
  [CONTEXTS_COLUMN_ID.SPACE]: "space",
};

const MAX_CELL_WIDTH = 600;

export const FILTER_TYPE = "contexts";
export const CONTEXTS_LIMIT = 50;
export const CONTEXTS_LIMIT_STORAGE_KEY = "contextsLimit";
export const CONTEXTS_COLUMNS_STORAGE_KEY = "contextsColumnsConfig";

export const CONTEXTS_COLUMN_CONFIG: Record<
  CONTEXTS_COLUMN_ID,
  TableColumnMeta<CONTEXTS_COLUMN_ID>
> = {
  [CONTEXTS_COLUMN_ID.NAME]: {
    id: CONTEXTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
  },
  [CONTEXTS_COLUMN_ID.DESCRIPTION]: {
    id: CONTEXTS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
  },
  [CONTEXTS_COLUMN_ID.LABELS]: {
    id: CONTEXTS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 100,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
  },
  [CONTEXTS_COLUMN_ID.SPACE]: {
    id: CONTEXTS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
  },
  [CONTEXTS_COLUMN_ID.CREATED_AT]: {
    id: CONTEXTS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 145,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
  },
  [CONTEXTS_COLUMN_ID.DROPDOWN]: {
    id: CONTEXTS_COLUMN_ID.DROPDOWN,
    title: "Context actions",
    noHeader: true,
    canHide: false,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    resizable: false,
  },
};

export const ROW_HEADER_ID = CONTEXTS_COLUMN_ID.NAME;

export const ANALYTICS = {
  analyticsPage: AnalyticsPageContext.ContextsList,
};
